import { render } from "./AllResultsPage.vue?vue&type=template&id=bda35fec"
import script from "./AllResultsPage.vue?vue&type=script&lang=js"
export * from "./AllResultsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__